export const cleaTalkData = [
  {
    'name': 'タイトルコール',
    'type': 'システム',
    'contents': [
      {
        'text': 'きららファンタジア、本日もよろしくお願いします',
        'voice': '' // TODO: url? filename?
      }
    ],
  },
  {
    'name': '起動時挨拶・朝',
    'type': 'システム',
    'contents': [
      {
        'text': 'おはようございます、今日も無理なく頑張りましょうね',
        'voice': ''
      },
      {
        'text': '朝顔ってお花は、とても早起きさんなんですよ',
        'voice': ''
      }
    ],
  },
  {
    'name': '起動時挨拶・夜',
    'type': 'システム',
    'contents': [
      {
        'text': '遅くまでお疲れ様です、明日も頑張りましょうね',
        'voice': ''
      },
      {
        'text': 'つい夜更かししてしまう気持ち、私もわかります',
        'voice': ''
      },
    ],
  },
  {
    'name': 'ホーム画面会話',
    'type': '里',
    'contents': [
      {
        'text': 'クレアです。召喚のお手伝いを\nさせてもらっています！',
        'voice': ''
      },
      {
        'text': 'みなさんを召喚するために必要な\n『鍵』の管理を任せていただいています。',
        'voice': ''
      },
      {
        'text': 'ポルカとコルクちゃんは、\nわたしの大切なお友達です。',
        'voice': ''
      },
      {
        'text': '元気が出ない時は、声を出すといいですよ。\nえいえい、おー！',
        'voice': ''
      },
    ],
  },
];
